import { Component, OnInit } from '@angular/core';
import { HomeSlider } from '../../../shared/data/slider';
import { Product } from '../../../shared/classes/product';
import { ProductService } from '../../../shared/services/product.service';
import { ApiProductService } from 'src/app/shared/api-services/product.service';
import { PixelService } from 'ngx-pixel'; 

@Component({
  selector: 'app-fashion-two',
  templateUrl: './fashion-two.component.html',
  styleUrls: ['./fashion-two.component.scss']
})
export class FashionTwoComponent implements OnInit {

  public themeLogo: string = 'web/assets/images/icon/logo.png'; // Change Logo

  public products: Product[] = [];
  public productCollections: any[] = ['new products'];
  public newProductCollection: Product[] = [];
  active;

  constructor(
    public productService: ProductService,
    private apiProductService: ApiProductService,
    private pixel: PixelService
  ) {
    
    this.apiProductService.products.subscribe(
      (products) => {
        // Shuffle array
        const shuffled = products.sort(() => 0.5 - Math.random());

        // Get sub-array of first n elements after shuffled
        let selected = shuffled.slice(0, 4);
        this.newProductCollection = selected;
      }
    );
  }

  public HomeSliderConfig: any = HomeSlider;

  public sliders = [{
    image: 'web/assets/images/homepage/slider-1.jpg',
    url: '/shop/product/7'
  }, {
    image: 'web/assets/images/homepage/slider-2.jpg',
    url: '/shop/product/6'
  }, {
    image: 'web/assets/images/homepage/slider-3.jpg',
    url: '/shop/product/4'
  }, {
    image: 'web/assets/images/homepage/slider-4.jpg',
    url: '/shop/product/14'
  }, {
    image: 'web/assets/images/homepage/slider-5.jpg',
    url: '/shop/product/15'
  }
]

 public grid: string = 'col-6';
 public layoutView: string = 'grid-view';

  // Collection banner
  public collections1 = [{
    image: 'web/assets/images/homepage/category/mtb.jpg',
    save: '',
    title: 'MTB',
    url: '/shop',
    queryParams: {
      main:'mtb',
      sub:'all'
    },
    styles: {
      left: '43%',
    }
  }, {
    image: 'web/assets/images/homepage/category/streetwear.jpg',
    save: '',
    title: 'STREETWEAR',
    url: '/shop',
    queryParams: {
      main:'streetwear',
      sub:'all'
    },
    styles: {
      left: '57%',
    }
  }];

  ngOnInit(): void {
    this.pixel.track('ViewContent', {
      content_name: 'Home Page'
    });
    
  }

}
